export default class GATracker {
  constructor(selector = '[data-ga-cat]'){
    this.selector = selector;
    this.categorySelector = 'data-ga-cat'
    this.labelSelector = 'data-ga-label'
    this.actionSelector = 'data-ga-action'
    this.trackers = Array.from(document.querySelectorAll(this.selector))

    this.events()
  }

  events(){
    this.trackers.forEach(el => el.addEventListener('click', this.pushEvent.bind(this, el)))
  }

  pushEvent(el, e){
    const category = el.getAttribute(this.categorySelector) || ''
    const action = el.getAttribute(this.actionSelector) || ''
    const label = el.getAttribute(this.labelSelector) || ''

    ga('send', 'event', category, action, label)
  }
}